// src/routes/gamma/index.tsx
import React, { useState } from 'react';
import {
  Container,
  Title,
  Paper,
  Group,
  Button,
  Stack,
} from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { RequestModal } from '../requests/components/RequestModal';
import { RequestsTableServerPaginated } from '../requests/components/RequestsTableServerPaginated';
import { useRequestTypePageState } from '../../hooks/use-request-type-page-state';
import {
  RequestTypeFilters,
  RequestStatusCountsBadges,
} from '../../components/requests/filters';
import { Request, RequestType as RequestTypeEnum } from '../../types/api';

export function GammaPage() {
  const navigate = useNavigate();
  const [createModalOpened, setCreateModalOpened] = useState(false);

  const state = useRequestTypePageState({
    type: RequestTypeEnum.Gamma,
    route: '/gamma',
  });

  const handleViewRequest = (id: number | string) => {
    navigate({ to: `/requests/${id}`, search: { from: '/gamma' } });
  };

  const handleEditRequest = (id: number | string) => {
    navigate({ to: `/requests/${id}/edit`, search: { from: '/gamma' } });
  };

  const handleRequestCreated = (_request: Request) => {
    setCreateModalOpened(false);
    state.invalidate();
  };

  return (
    <Container size="xl" py="lg">
      <Stack gap="md">
        <Group justify="space-between">
          <Title order={2}>Gamma</Title>
          <Button
            color="blue"
            leftSection={<IconPlus size={16} />}
            onClick={() => setCreateModalOpened(true)}
            styles={{ label: { color: 'white' }, section: { color: 'white' } }}
          >
            Nuova Richiesta Gamma
          </Button>
        </Group>

        <Paper withBorder p="md">
          <Stack gap="md">
            <RequestStatusCountsBadges
              type={RequestTypeEnum.Gamma}
              aggregates={state.aggregates}
              loading={state.aggregatesLoading}
              activeStatus={state.activeStatus}
              onStatusToggle={state.handleStatusToggle}
            />

            <RequestTypeFilters
              value={state.filters}
              onChange={state.handleFiltersChange}
              onReset={state.handleResetFilters}
              availableYears={state.availableYears}
              searchPlaceholder="Cerca per titolo, descrizione, N. progressivo (es. 5/2025)..."
            />

            <RequestsTableServerPaginated
              data={state.items}
              onView={handleViewRequest}
              onEdit={handleEditRequest}
              loading={state.isLoading}
              fetching={state.isFetching}
              totalCount={state.totalCount}
              totalPages={state.totalPages}
              pageNumber={state.pageNumber}
              pageSize={state.pageSize}
              onPageChange={state.handlePageChange}
              onPageSizeChange={state.handlePageSizeChange}
            />
          </Stack>
        </Paper>
      </Stack>

      <RequestModal
        opened={createModalOpened}
        onClose={() => setCreateModalOpened(false)}
        mode="create"
        onSuccess={handleRequestCreated}
        defaultRequestType="4"
      />
    </Container>
  );
}
